import { createSelector } from 'reselect';
import { reducerProductsName } from './constants';
import { initialState } from './reducer';
var productsManagerStorageSelector = function (store) {
    return store[reducerProductsName] || initialState;
};
export var getProductsMenuData = createSelector(productsManagerStorageSelector, function (_a) {
    var menu = _a.menu;
    return menu;
});
export var getProductsData = createSelector(productsManagerStorageSelector, function (_a) {
    var products = _a.products;
    return products;
});
export var getProductsMenuIsLoading = createSelector(productsManagerStorageSelector, function (_a) {
    var loading = _a.loading;
    return loading;
});
export var getSelectedMenuItem = createSelector(productsManagerStorageSelector, function (_a) {
    var selectedItem = _a.selectedItem;
    return selectedItem;
});
export var getReloadNotificationIsShown = createSelector(productsManagerStorageSelector, function (_a) {
    var isReloadNotificationShown = _a.isReloadNotificationShown;
    return isReloadNotificationShown;
});
